import React, { useEffect, useState } from 'react';

const CONSENT_KEY = 'itcode_cookie_consent';
const GA_ID = 'G-B3RVSSJWS0';
const FB_PIXEL_ID = '608054885365146';

export function loadTrackers() {
    // Google Consent Mode v2 — tell Google's tags storage is now allowed.
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('consent', 'update', {
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
        'analytics_storage': 'granted'
    });

    if (window.__itcodeTrackersLoaded) return;
    window.__itcodeTrackersLoaded = true;

    // Google Analytics (gtag.js)
    const gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(gaScript);

    gtag('js', new Date());
    gtag('config', GA_ID);

    // Meta (Facebook) Pixel
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', FB_PIXEL_ID);
    window.fbq('track', 'PageView');
}

export function loadCalendly() {
    if (window.__itcodeCalendlyLoaded) return;
    window.__itcodeCalendlyLoaded = true;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    script.onload = function () {
        if (window.Calendly) {
            window.Calendly.initBadgeWidget({
                url: "https://calendly.com/itcodeinfotech/itcode_infotech_tech_solutions",
                text: "Schedule time with me",
                color: "#0069ff",
                textColor: "#ffffff",
                branding: true,
            });
        }
    };
    document.head.appendChild(script);
}

const CookieConsentBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const consent = localStorage.getItem(CONSENT_KEY);
            if (consent === 'accepted') {
                loadTrackers();
                loadCalendly();
            } else if (consent !== 'declined') {
                setVisible(true);
            }
        } catch (e) {
            // localStorage unavailable — don't load trackers, don't block rendering
        }
    }, []);

    const accept = () => {
        try { localStorage.setItem(CONSENT_KEY, 'accepted'); } catch (e) {}
        loadTrackers();
        loadCalendly();
        setVisible(false);
    };

    const decline = () => {
        try { localStorage.setItem(CONSENT_KEY, 'declined'); } catch (e) {}
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-consent-banner" role="dialog" aria-label="Cookie consent">
            <div className="cookie-consent-inner">
                <p>
                    We use cookies, including third-party cookies from Google and
                    Meta, to analyze traffic and to personalize ads. By clicking
                    "Accept", you consent to this use. Read our{' '}
                    <a href={process.env.PUBLIC_URL + '/privacy-policy'}>Privacy Policy</a>{' '}
                    to learn more or to opt out.
                </p>
                <div className="cookie-consent-actions">
                    <button type="button" className="axil-btn btn-borderd" onClick={decline}>Decline</button>
                    <button type="button" className="axil-btn btn-fill-primary" onClick={accept}>Accept</button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsentBanner;
